var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "full-height",
      staticStyle: { padding: "20px", "padding-bottom": "0", height: "100%" },
    },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.panel,
            callback: function ($$v) {
              _vm.panel = $$v
            },
            expression: "panel",
          },
        },
        [
          _c("el-tab-pane", {
            attrs: { label: "國家排序設定", name: "country" },
          }),
          _c("el-tab-pane", { attrs: { label: "熱門國家設定", name: "hotC" } }),
        ],
        1
      ),
      _vm.panel == "hotC"
        ? _c(
            "div",
            { staticStyle: { "padding-bottom": "0" } },
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", disabled: _vm.listLoading },
                          on: { click: _vm.addData },
                        },
                        [_vm._v("建立")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
                "row-key": "id",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "ID", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                    },
                  },
                ]),
              }),
              _vm.panel == "hotC"
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "圖片", width: "300" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-image", {
                                staticStyle: { height: "50px" },
                                attrs: {
                                  src: scope.row.fileInfo[0].files[0].url,
                                  fit: "contain",
                                  "preview-src-list": [
                                    scope.row.fileInfo[0].files[0].url,
                                  ],
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1628455704
                    ),
                  })
                : _vm._e(),
              _vm.panel == "hotC"
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "標題", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.title))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1808518502
                    ),
                  })
                : _c("el-table-column", {
                    attrs: { align: "center", label: "標題", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_c("span", [_vm._v(_vm._s(scope.row.label))])]
                        },
                      },
                    ]),
                  }),
              _c("el-table-column", {
                attrs: { align: "center", label: "排序", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.sort))])]
                    },
                  },
                ]),
              }),
              _vm.panel == "hotC"
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "國家", width: "350" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _vm._l(
                              _vm.showCountry(scope.row.countries),
                              function (item) {
                                return _c(
                                  "p",
                                  {
                                    key: item,
                                    staticStyle: { margin: "2px 0px" },
                                  },
                                  [_vm._v(" " + _vm._s(item) + " ")]
                                )
                              }
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      1897834787
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.checkPermission(["ITA-DEV"])
                ? _c("el-table-column", {
                    attrs: { label: "刪除", width: "100", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(scope)
                                    },
                                  },
                                },
                                [_vm._v("刪除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2604068638
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { border: "2px solid #ccc" },
          attrs: {
            title: "編輯",
            visible: _vm.dialogFormVisible,
            width: "50%",
            top: "1%",
          },
          on: {
            closed: _vm.onDialogClosed,
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              staticClass: "box-card",
              attrs: { "body-style": { border: "1px solid #ccc" } },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "dynamicValidateForm",
                          attrs: { model: _vm.formData },
                        },
                        [
                          _vm.panel == "hotC"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "圖片",
                                    "label-width": _vm.formLabelWidth,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("Upload", {
                                        ref: "uploadRef",
                                        attrs: {
                                          accept: ".jpg,.jpeg,.png",
                                          payload: _vm.formData,
                                          "data-obj": _vm.fileObj,
                                          "limit-file-count": 1,
                                          limitText:
                                            "圖片尺寸:280x100，須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                                          "use-drag": false,
                                          action: "ToursCombine/saveHotCountry",
                                          "auto-upload": false,
                                          "show-file-list": true,
                                          "form-on-loading-parent":
                                            _vm.formLoading,
                                          "btn-txt": "上傳",
                                          "before-file-list":
                                            _vm.formData.fileInfo &&
                                            _vm.formData.fileInfo.length
                                              ? _vm.formData.fileInfo[0].files
                                              : [],
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.panel == "hotC"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "標題",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "title",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸入標題",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formData.title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "title", $$v)
                                      },
                                      expression: "formData.title",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "排序",
                                "label-width": _vm.formLabelWidth,
                                prop: "sort",
                                rules: [
                                  {
                                    required: true,
                                    message: "請輸入排序",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off", type: "number" },
                                model: {
                                  value: _vm.formData.sort,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "sort", $$v)
                                  },
                                  expression: "formData.sort",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.panel == "hotC"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "國家",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "countries",
                                    rules: [
                                      {
                                        type: "array",
                                        message: "型別錯誤",
                                        trigger: "blur",
                                      },
                                      {
                                        required: true,
                                        message: "請選擇國家",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-cascader", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      options: _vm.cascaderCountryOptions,
                                      props: {
                                        multiple: true,
                                        value: "id",
                                      },
                                      "collapse-tags": "",
                                    },
                                    model: {
                                      value: _vm.formData.countries,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "countries", $$v)
                                      },
                                      expression: "formData.countries",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("dynamicValidateForm")
                    },
                  },
                },
                [_vm._v("儲 存")]
              ),
              _c("el-button", { on: { click: _vm.onDialogClosed } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }